import { gql } from "@apollo/client";

export const COMPETITOR_PRESENCE_BY_DEPARTMENT_QUERY = gql`
  query competitorPresenceByDepartment(
    $companyFilters: CompanyFilter!
    $productIds: [Int]!
    $localizeInstalls: Boolean = true
    $installAge: Int = 24
    $companyMatchFile: CompanyMatchFilter
  ) {
    presenceByDepartment(
      companyFilters: $companyFilters
      productIds: $productIds
      localizeInstalls: $localizeInstalls
      installAge: $installAge
      companyMatchFile: $companyMatchFile
    ) {
      faiDepartmentId
      faiDepartmentName
      # installsCount is actually companyCount, to be renamed in the backend
      installsCount
    }
  }
`;

export interface CompetitorPresenceByDepartmentPayload {
  presenceByDepartment: {
    faiDepartmentId: number;
    faiDepartmentName: string;
    installsCount: number;
  }[];
}
